import React from 'react';

import DataTableBlur from 'components/DataTableBlur/DataTableBlur';
import MessageModal from 'components/DeniedAccessMessageModal';

const PermissionError: React.FC = () => {
  return (
    <>
      <MessageModal />
      <DataTableBlur />
    </>
  );
};

export default PermissionError;
